import type { ComponentPropsWithoutRef, FC } from "react";
import styled from "styled-components";

import { pageStyle } from "../styles/pageStyles";
import { Breadcrumbs } from "./Content/components/Breadcrumbs";

const StyledPage = styled.div`
    ${pageStyle};
`;

const StyledHeaderContainer = styled.div`
    ${pageStyle};
`;

const StyledHeaderRow = styled.div`
    ${pageStyle};
`;

const StyledTitle = styled.div`
    ${pageStyle};
`;

const StyledContent = styled.div`
    ${pageStyle};
`;

export const FPage = styled(StyledPage).attrs(() => ({ className: "aevi-page-container" as string }))``;

const HeaderRow = styled(StyledHeaderRow).attrs(() => ({ className: "aevi-page-header-row" as string }))``;

/**
 * Breadcrumbs render above the title/action-bar row, pushing it down, so the title stays
 * aligned with the action bar exactly as it was before breadcrumbs existed.
 */
export const FPageHeader: FC<ComponentPropsWithoutRef<"div">> = ({ children, className, ...rest }) => (
    <StyledHeaderContainer className={["aevi-page-header", className].filter(Boolean).join(" ")} {...rest}>
        <Breadcrumbs />
        <HeaderRow>{children}</HeaderRow>
    </StyledHeaderContainer>
);

export const FPageTitle = styled(StyledTitle).attrs(() => ({ className: "aevi-page-title" as string }))``;

export const FPageContent = styled(StyledContent).attrs(() => ({ className: "aevi-page-content" as string }))``;
